import { randomInt } from 'es-toolkit'

export const randomIntExcluding = (existingIds: number[]) => {
  let id = randomInt(1000)
  while (existingIds.includes(id)) {
    id = randomInt(1000)
  }
  return id
}
